import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Dialog,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import { getPolicyByIdAction, updatePolicyAction } from '../../../redux/actions/policyActions';
import EditPolicyUserDetail from './EditPolicyUserDetail';
import dayjs from "dayjs";
import { stateList } from '../../../common/StaticFieldList';

const poppinsFont = {
  fontFamily: '"Poppins", sans-serif',
};

const PolicyUserDetails = ({ policy_Id, selectedRowId }) => {
  const dispatch = useDispatch();
  const customerData = useSelector((state) => state.policy.getPolicy) || {};

  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const id = policy_Id || selectedRowId;
    if (id) {
      dispatch(getPolicyByIdAction(id));
    }
  }, [dispatch, policy_Id, selectedRowId]);

  useEffect(() => {
    if (customerData) {
      setFormData({
        firstName: customerData.firstName || '',
        lastName: customerData.lastName || '',
        dateOfBirth: customerData.dateOfBirth || '',
        gender: customerData.gender || '',
        email: customerData.emailId || '',
        address: customerData.address || '',
        zip: customerData.zip || '',
        city: customerData.city || '',
        state: customerData.state || '',
        yearsAtResidence: customerData.yearsAtResidence || '',
        tax: customerData.taxId || '',
        ownershipStatus: customerData.ownershipStatus || '',
        id: policy_Id || customerData.id,
      });
    }
  }, [customerData, policy_Id]);

  const handleEditClick = (data) => {
    setFormData(data)
    setOpenDialog(true);
  };

const handleDialogClose = (event, reason) => {
  if (reason === "backdropClick" || reason === "escapeKeyDown") {
    return;
  }
  setOpenDialog(false);
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toE164US = (v) => {
    if (!v) return "";
    let d = v.replace(/\D/g, "");

    if (d.length === 11 && d.startsWith("1")) {
      d = d.slice(1);
    }

    if (d.length !== 10) {
      return v;
    }

    return `+1${d}`;
  };
 const handleSubmit = (payload) => {
  const normalizedPayload = {
    ...payload,
    phoneNumber: toE164US(payload.phoneNumber),
  };

  dispatch(updatePolicyAction(normalizedPayload));
  dispatch(getPolicyByIdAction(policy_Id));
  setOpenDialog(false);
};

const getStateName = (code) => {
  if (!code) return "-";
  const state = stateList.find((s) => s.value === code);
  return state ? state.label : code;
};

  return (
    <TableContainer sx={{ verticalAlign: 'Top' }} component={Paper}>
      <Table sx={{ verticalAlign: 'Top' }}>
        <TableBody>
          <TableRow>
            <TableCell align="right" colSpan={3}>
              <EditIcon onClick={()=> handleEditClick(customerData)} style={{ cursor: 'pointer' }} />
            </TableCell>
          </TableRow>
          <TableRow sx={{ verticalAlign: 'Top' }}>
            <TableCell>
              <Table>
                <TableBody>
                <TableRow>
                  <TableCell id="firstname" sx={poppinsFont}>
                    <strong>First Name:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>{customerData.firstName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell id="lastname" sx={poppinsFont}>
                    <strong>Last Name:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>{customerData.lastName}</TableCell>
                </TableRow>
                <TableRow>

                <TableCell id="dateofBirth" sx={poppinsFont}>
                <strong>Date of Birth:</strong>
                </TableCell>
                <TableCell sx={poppinsFont}>
                {customerData.dateOfBirth
                ? dayjs(customerData.dateOfBirth).format("MM-DD-YYYY")
                  : "-"}
                </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell id="gender" sx={poppinsFont}>
                    <strong>Gender:</strong>
                  </TableCell>
                <TableCell sx={poppinsFont}>
  {customerData.gender === 'M' ? 'Male' : customerData.gender === 'F' ? 'Female' : customerData.gender}
</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell id="email" sx={poppinsFont}>
                    <strong>Email:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>{customerData.emailId}</TableCell>
                </TableRow>
                </TableBody>
              </Table>
            </TableCell>
            <TableCell>
              <Table>
                <TableBody>
                <TableRow>
                  <TableCell id="address" sx={poppinsFont}>
                    <strong>Address:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>{customerData.address}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell id="city" sx={poppinsFont}>
                    <strong>City:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>{customerData.city}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell id="state" sx={poppinsFont}>
                    <strong>State:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>{getStateName(customerData.state)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell id="zip" sx={poppinsFont}>
                    <strong>Zip:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>{customerData.zipCode}</TableCell>
                </TableRow>
                </TableBody>
              </Table>
            </TableCell>
            <TableCell>
              <Table>
                <TableBody>
                <TableRow>
                  <TableCell id="yearsatresidence" sx={poppinsFont}>
                    <strong>Years at Residence:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>
                      {customerData?.residenceYear ? `${customerData.residenceYear} years` : ''}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell id="monthsatresidence" sx={poppinsFont}>
                    <strong>Months at Residence:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>
                    {customerData?.residenceMonth ? `${customerData.residenceMonth} Month` : ''}
                    </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell id="monthsatresidence" sx={poppinsFont}>
                    <strong>Status:</strong>
                  </TableCell>
                  <TableCell sx={poppinsFont}>
                    {customerData?.status}
                    </TableCell>
                </TableRow>
                </TableBody>
              </Table>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Dialog open={openDialog} onClose={handleDialogClose} disableScrollLock={true} keepMounted={false} hideBackdrop={false} style={{ zIndex: 1300 }}>
        <EditPolicyUserDetail
          handleChange={handleChange}
          formData={formData}
          handleDialogClose={handleDialogClose}
          handleSubmit={handleSubmit}
          setFormData={setFormData}
        />
      </Dialog>
    </TableContainer>
  );
};

export default PolicyUserDetails;
